 const actions={
GET_Client_DATA:"GET_Client_DATA",
GET_Companies_DATA:"GET_Companies_DATA",
GET_Info_DATA:"GET_Info_DATA",
SAVE_IN_INFO:"SAVE_IN_INFO",
SIGN_IN_INFO:"SIGN_IN_INFO",
}
export default actions